function normalizeAuth0Domain(domain) {
    return String(domain || "")
        .trim()
        .replace(/^https?:\/\//, "")
        .replace(/\/+$/, "");
}

export async function requestAuth0PasswordResetEmail({
    domain,
    clientId,
    email,
    connection,
}) {
    const normalizedDomain = normalizeAuth0Domain(domain);
    if (!normalizedDomain)
        throw new Error("Missing Auth0 domain configuration.");
    if (!clientId) throw new Error("Missing Auth0 client ID configuration.");
    if (!email) throw new Error("Missing email address.");
    if (!connection) throw new Error("Missing Auth0 database connection.");

    const res = await fetch(
        `https://${normalizedDomain}/dbconnections/change_password`,
        {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify({
                client_id: clientId,
                email,
                connection,
            }),
        }
    );

    const text = await res.text();
    if (!res.ok) throw new Error(text || "Failed to send password reset email.");
    return text;
}
